import React from "react";
import Grid from "@material-ui/core/Grid";
import { useRptAF } from "../../../../St/Reviews/UseStyle";
import { useTranslation } from "react-i18next";
import { useRptCa } from '../../../../St/Reviews/UseStyle';
import { reFormatDate, reFormatTime } from "../../../../utils/utils";
import { styleFooterNotesAr } from "../../../Invs/ShareFunctionsPrint";
export function Totals({ infoData }) {

    const { t } = useTranslation(["forms"]);

    const styleE = {
        border: "solid 1px ",
        borderColor: "black",
        textAlign: "center",
        paddingTop: "0.1rem",
        paddingBottom: "0.1rem",
        fontSize: "0.8rem",
        color: "black",
        fontWeight: "bold",
    };
    const styleTo = {
        border: "solid 1px ",
        borderColor: "black",
        textAlign: "center",
        fontSize: "0.8rem",
        fontWeight: "bold",
    };
    return (
        <Grid item container >
            <Grid item container style={{ fontFamily: "Amiri-Regular", marginBottom: "0.5rem", marginTop: "0.7rem" }}>
                <Grid item xs={7} style={styleE}>
                    {'صافي نقدي'}
                </Grid>
                <Grid item xs={5} style={styleE}>
                    {infoData.tot.totRsedStok?.toFixed(2)}
                </Grid>
                <Grid item xs={7} style={styleE}>
                    {'صافي الشبكة'}
                </Grid>
                <Grid item xs={5} style={styleE}>
                    {infoData.tot.totRsedNetW?.toFixed(2)}
                </Grid>
                <Grid item xs={7} style={styleE}>
                    {'صافي البنك'}
                </Grid>
                <Grid item xs={5} style={styleE}>
                    {infoData.tot.totBanks?.toFixed(2)}
                </Grid>
                <Grid item xs={7} style={styleE}>
                    {'صافي الاجل'}
                </Grid>
                <Grid item xs={5} style={styleE}>
                    {infoData.tot.totAgels?.toFixed(2)}
                </Grid>
                {infoData?.is_comm &&
                    <>
                        <Grid item xs={7} style={styleE}>
                            {"اجمالي التحصيلات"}
                        </Grid>
                        <Grid item xs={5} style={styleE}>
                            {infoData.total_naqed.toFixed(2)}
                        </Grid>
                        <Grid item xs={7} style={styleE}>
                            {"عمولة التحصيل"}
                        </Grid>
                        <Grid item xs={5} style={styleE}>
                            {infoData.comm_receipt.toFixed(2)}
                        </Grid>
                    </>
                }
            </Grid>
        </Grid>
    );
}

export function TotalsEqfal({ infoData }) {

    const { t } = useTranslation(["forms"]);

    const styleE = {
        border: "solid 1px ",
        borderColor: "black",
        textAlign: "center",
        paddingTop: "0.1rem",
        paddingBottom: "0.1rem",
        fontSize: "0.8rem",
        color: "black",
        fontWeight: "bold",
    };

    return (
        <Grid item container >
            <Grid item container style={{ fontFamily: "Amiri-Regular", marginBottom: "0.5rem", marginTop: "0.7rem" }}>
                <Grid item xs={7} style={styleE}>
                    {'إجمالي المبيعات - المرتجع'}
                </Grid>
                <Grid item xs={5} style={styleE}>
                    {infoData.tot.totSal?.toFixed(2)}
                </Grid>
                <Grid item xs={7} style={styleE}>
                    {'إجمالي الآجل'}
                </Grid>
                <Grid item xs={5} style={styleE}>
                    {infoData.tot.totAjel?.toFixed(2)}
                </Grid>
                <Grid item xs={7} style={styleE}>
                    {'صافي نقدي'}
                </Grid>
                <Grid item xs={5} style={styleE}>
                    {infoData.tot.totNetAmount?.toFixed(2)}
                </Grid>
                <Grid item xs={7} style={styleE}>
                    {'صافي شبكة + بنك'}                </Grid>
                <Grid item xs={5} style={styleE}>
                    {infoData.tot.totNetAndBank?.toFixed(2)}
                </Grid>
                <Grid item xs={7} style={styleE}>
                    {' صافي '}{t("paid")}
                </Grid>
                <Grid item xs={5} style={styleE}>
                    {(parseFloat(infoData.tot.totNetAmount) + parseFloat(infoData.tot.totNetAndBank)).toFixed(2)}
                </Grid>
            </Grid>
        </Grid>
    );
}


function BodyCashiar({ infoData }) {
    const { t } = useTranslation(["forms", "translation"]);
    const cls = useRptAF();
    const clas = useRptCa();

    const cellS = {
        padding: "0px 0.1px",
        textAlign: "-webkit-center",
        margin: "0px",
        whiteSpace: "normal",
        border: "solid 0.1px",
        fontSize: "1.1rem",
        width: "250px",
        textAlign: "right",
        paddingRight: "0.85rem",
        fontFamily: "Amiri-Regular",
        fontWeight: "bold",
        paddingTop: "0.1rem",
        paddingBottom: "0.1rem"
    };

    const newData = infoData.data?.map((row, i) => {
        return {
            ...row,
            total: parseFloat(row?.total ?? 0).toFixed(2),
        };
    });
    const styleE = {
        border: "solid 1px ",
        borderColor: "black",
        textAlign: "center",
        fontSize: "1rem",
        color: "black",
        fontWeight: "bold",
    };
    const styleE2 = {
        textAlign: "center",
        fontSize: "1rem",
        color: "black",
        fontWeight: "bold",
    };
    return (
        <Grid item container style={{ fontFamily: "Amiri-Regular" }}>
            <Grid item container style={{ direction: "rtl", paddingTop: "0.7rem" }}>

                <Grid item container className={clas.Bdycntr}>
                    <Grid item container style={{ justifyContent: 'center', }}>
                        <Grid item xs={4} style={styleE2} >{'من تاريخ'}</Grid>
                        <Grid item xs={8} style={styleE2} >{reFormatDate(infoData.fDate)} {"  "} {reFormatTime(infoData.fDate)}</Grid>
                        <Grid item xs={4} style={styleE2}>{'إلى تاريخ'}</Grid>
                        <Grid item xs={8} style={styleE2}>{reFormatDate(infoData.tDate)} {"  "} {reFormatTime(infoData.tDate)}</Grid>
                    </Grid>
                </Grid>

                <Grid container xs={12}>
                    {infoData.kind !== 4 &&
                        <>
                            <Grid item xs={6} style={styleE}>
                                {infoData?.kind == 2 ? "نوع الحركة" : "رقم الوردية"}
                            </Grid>
                            <Grid item xs={6} style={styleE}>
                                {infoData?.kind == 2 ? "الاجمالي" : infoData.transNo}
                            </Grid>
                        </>
                    }

                    {newData?.map((d) => {
                        return (
                            <Grid
                                xs={12}
                                container
                                item
                            >
                                <Grid item xs={6} style={{...cellS,fontSize:infoData?.kind !== 4?"1.1rem":"12px"}}>
                                    {infoData?.kind !== 4 ? d?.title : d.name}
                                </Grid>
                                <Grid item xs={6} style={{...cellS,fontSize:infoData?.kind !== 4?"1.1rem":"12px"}}>
                                    {infoData?.kind !== 4 ? d.total : d?.TotalFloat}
                                </Grid>
                            </Grid>
                        );
                    })}
                </Grid>
                {infoData?.kind !== 4? <Totals infoData={infoData} />:<TotalsEqfal infoData={infoData} />}

            </Grid>
            {infoData?.kind == 1 &&
                <Grid item xs={12} className={"invoice-footerar"}
                    style={styleFooterNotesAr} >
                    {infoData?.notes}
                </Grid>
            }
        </Grid>
    );
}

export default BodyCashiar;
